import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import onezapplogo from "../../assets/img/Zapp.svg";
import footerfacebookicon from "../../assets/img/facebook icon.svg";
import footerinstagramicon from "../../assets/img/instagram icon.svg";
import footerlinkedinicon from "../../assets/img/linkedin icon .svg";
import footertwittericon from "../../assets/img/twitter icon.svg";
import playstore from "../../assets/img/playstore.svg";

import { ComingSoon } from "../dialogs/ComingSoon";
import { IoIosLock } from "react-icons/io";
import { NavDropdown } from "react-bootstrap";
function Header() {
  // const navbarCollapse = () => {
  //   window.reload();
  // };

  return (
    <header className="sticky-top">
      <div className="container">
        <nav className="navbar navbar-expand-lg ">
          <a href="/" className="brand-logo">
            <img src={onezapplogo} />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav w-100 d-lg-flex justify-content-end">
              <span className="footer__hr1"></span>
              <li className="nav-item active nav-link ">
                <NavLink
                  exact
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "selected" : "unselected"
                  }
                  // onClick={navbarCollapse}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item nav-link ">
                <NavLink
                  exact
                  to="/about"
                  className={({ isActive }) =>
                    isActive ? "selected" : "unselected"
                  }
                  // onClick={navbarCollapse}
                >
                  About Us{" "}
                </NavLink>
              </li>
              <li className="nav-item nav-link ">
                <NavLink
                  exact
                  to="/contact"
                  className={({ isActive }) =>
                    isActive ? "selected" : "unselected"
                  }
                  // onClick={navbarCollapse}
                >
                  Contact Us
                </NavLink>
              </li>
              {/* <li className="nav-item nav-link ">
                <NavLink
                  exact
                  to="/careers"
                  className={({ isActive }) =>
                    isActive ? "selected" : "unselected"
                  }
                  onClick={navbarCollapse}
                >
                  Careers
                </NavLink>
              </li> */}
              <NavDropdown title="My Account" id="myAccount" align="end">
                <NavDropdown.Item
                  as={NavLink}
                  exact
                  to="/delete-account"
                  // onClick={navbarCollapse}
                >
                  Delete Account
                </NavDropdown.Item>
              </NavDropdown>

              <li className="nav-item">
                <a
                  className="btn btn-home-download"
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.epSystems.oneZap.android.app"
                >
                  Download App
                  <img className="home__playbutton" src={playstore} />
                </a>
              </li>
            </ul>
            <p className="footer__hr"></p>

            <ul className="navbar-nav mobile-link">
              {/* <li className="nav-item nav-link ">
                <NavLink
                  exact
                  to="/charges"
                  className={({ isActive }) =>
                    isActive ? "selected" : "unselected"
                  }
                  onClick={navbarCollapse}
                >
                  Schedule of Charges
                </NavLink>
              </li> */}
              <li className="nav-item nav-link ">
                <NavLink
                  exact
                  to="/faqs"
                  className={({ isActive }) =>
                    isActive ? "selected" : "unselected"
                  }
                  // onClick={navbarCollapse}
                >
                  FAQs
                </NavLink>
              </li>
              <li className="nav-item nav-link ">
                <NavLink
                  exact
                  to="/privacy-policy"
                  className={({ isActive }) =>
                    isActive ? "selected" : "unselected"
                  }
                  // onClick={navbarCollapse}
                >
                  Privacy Policy
                </NavLink>
              </li>
              <li className="nav-item nav-link ">
                <NavLink
                  exact
                  to="/terms-and-conditions"
                  className={({ isActive }) =>
                    isActive ? "selected" : "unselected"
                  }
                  // onClick={navbarCollapse}
                >
                  Terms & Conditions
                </NavLink>
              </li>
              <br></br>

              <div className="d-flex flex-wrap align-content-end mt-5">
                <div className="footer__icon-div d-flex justify-content-center w-100 mb-2">
                  <div className="footer__shocialicon me-3">
                    <a href="https://www.facebook.com/onezappk" target="_blank">
                      <img src={footerfacebookicon}></img>
                    </a>
                  </div>
                  <div className="footer__shocialicon me-3">
                    <a href="https://twitter.com/onezappk" target="_blank">
                      <img src={footertwittericon}></img>
                    </a>
                  </div>
                  <div className="footer__shocialicon me-3">
                    <a
                      href="https://www.instagram.com/onezapp.pk/"
                      target="_blank"
                    >
                      <img src={footerinstagramicon}></img>
                    </a>
                  </div>
                  <div className="footer__shocialicon">
                    <a
                      href="https://www.linkedin.com/company/onezappk/"
                      target="_blank"
                    >
                      <img src={footerlinkedinicon}></img>
                    </a>
                  </div>
                </div>
                <p className="copyright-mob text-sm text-center w-100">
                  Copyright 2022 OneZapp | All Right Reserved
                </p>
              </div>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
}
export default Header;
